/* eslint prefer-template:0, sort-imports:0 */
import _isBot from 'santa-main-r/lib/lib/common/isBot.js'
import _isSuspectedBot from 'santa-main-r/lib/lib/common/isSuspectedBot.js' // This should be before the Polyfill

const isBot = _isBot(window)
const isSuspectedBot = _isSuspectedBot(window)

import experimentFactory from 'santa-main-r/lib/lib/common/experimentFactory.js'
import PackagesUtil from 'santa-main-r/lib/lib/common/PackagesUtil.js'
import _convertSiteModel from 'santa-main-r/lib/lib/viewer/convertSiteModel.js'
import _render from 'santa-main-r/lib/lib/viewer/render.js'
import addExperimentsFromQuery from 'santa-main-r/lib/lib/common/addExperimentsFromQuery.js'
import applyPackagesCache from 'santa-main-r/lib/lib/common/applyPackagesCache.js'
import {getBaseVersion} from 'santa-main-r/lib/lib/common/getBaseVersion.js'
import getFullRjsConfig from 'santa-main-r/lib/lib/common/getFullRjsConfig.js'
import {getPageInfo} from 'santa-main-r/lib/lib/viewer/utils.js'
import getQueryUtils from 'santa-main-r/lib/lib/common/getQueryUtils.js'
import getSubdomain from 'santa-main-r/lib/lib/common/getSubdomain.js'
import instruments from 'santa-main-r/lib/lib/viewer/instruments.js'
import joinURL from 'santa-main-r/lib/lib/common/joinURL.js'
import mobile from 'santa-main-r/lib/lib/viewer/mobile.js'
import overrideScriptsLocationMapFromQuery from 'santa-main-r/lib/lib/common/overrideScriptsLocationMapFromQuery.js'
import requirejs from 'requirejs'
import resourcePrefetch from 'santa-main-r/lib/lib/viewer/resourcePrefetch.js'
import rjsConfig from 'santa-main-r/lib/lib/viewer/rjs-config.js'
import storageUtil from 'santa-main-r/lib/lib/common/storageUtil.js'
import Raven from 'raven-js'
import * as Sentry from '@sentry/browser'
import isCached from 'santa-main-r/lib/lib/viewer/isCached.js'

const options = require('../../../dist/options.json')

const sentryForViewerProjectLink = 'https://c22b509a2a2844068e609ca596c6bbdc@sentry.io/263673'
const sentryForPreviewProjectLink = 'https://c2ecf1da946d45faa10573445a9b239c@sentry.io/287491'
const packages = require('../../../dist/packagesList.json')
const {rendererModel, publicModel, serviceTopology = {}, commonConfig = {}} = window

window.persistent = storageUtil(window) // TODO: how is this used?
const queryUtil = getQueryUtils(window)
window.queryUtil = queryUtil

const experimentInst = experimentFactory.build(window)
const render = _render(window, requirejs, isBot, experimentInst)
const packagesUtil = new PackagesUtil(packages, window.location.search, options.bundles)
const getViewerRjsConfig = rjsConfig(window, options.versions, experimentInst)
const {sendErrorOrQueue, instrument} = instruments(window, requirejs, isBot, isSuspectedBot, experimentInst)
const convertSiteModel = _convertSiteModel(window, sendErrorOrQueue)
const isPreview = queryUtil.isParameterTrue('isEdited')
const hasPageIdInHash = window.location.hash && window.location.hash !== '#!'
let isServerSide = window.isStreaming //eslint-disable-line santa/no-module-state

if (isServerSide && hasPageIdInHash) {
  window.isServerSideWithHash = true
  isServerSide = false
}

const {wixBiSession = {}} = window
window.wixBiSession = wixBiSession
wixBiSession.mainLoaded = Date.now()
wixBiSession.et = 1
wixBiSession.isCached = isCached(window)

serviceTopology.scriptsLocationMap = overrideScriptsLocationMapFromQuery(serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'))

rendererModel.runningExperiments = addExperimentsFromQuery(rendererModel.runningExperiments, queryUtil, 'viewer')


window.siteModel = convertSiteModel(rendererModel, publicModel, commonConfig)

if (!publicModel && experimentInst.isOpen('ds_sentrySDK')) {
  Sentry.init({
    dsn: sentryForPreviewProjectLink
  })
  window.siteModel.SentrySDK = Sentry
} else if (!publicModel && experimentInst.isOpen('sv_includeRavenInPreview')) {
  Raven.config(sentryForPreviewProjectLink).install()
} else if (publicModel && experimentInst.isOpen('sv_includeRavenInViewerSSR')) {
  Raven.config(sentryForViewerProjectLink).install()
}

window.siteModel.Raven = Raven

const {siteModel} = window
const {premiumFeatures} = rendererModel
const isPremium = !!premiumFeatures && premiumFeatures.indexOf('HasDomain') !== -1

const pageInfo = rendererModel && getPageInfo(window, rendererModel.pageList, isPremium)

const performanceBI = instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo, isPremium, isServerSide)

if (publicModel && !options.disableCheckRenderTime) {
  if (Math.abs(Date.now() - publicModel.renderTime) > 2592e5) {
    wixBiSession.sendError({
      errorName: 'Error #2592e5',
      errorCode: 111026
    })
    throw new Error('Error #2592e5')
  }
}

if (isServerSide && !window.messageBuffer) {
  window.addEventListener('message', siteModel.messageHandler, false)
}

if (window.karmaIntegration) {
  siteModel.documentServicesModel = siteModel.documentServicesModel || window.karmaIntegration.documentServicesModel
  siteModel.wixapps = siteModel.wixapps || {}
  siteModel.wixapps.appbuilder = siteModel.wixapps.appbuilder || {}
  siteModel.wixapps.appbuilder.descriptor = siteModel.wixapps.appbuilder.descriptor || {}
  siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion = siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion || {}
}

const config = getFullRjsConfig(
  'santa',
  window.santaBase,
  getViewerRjsConfig(serviceTopology),
  packagesUtil,
  serviceTopology
)

if (!options.disablePackagesCache) {
  applyPackagesCache({
    proj: 'santa',
    paths: config.paths,
    manifest: options.manifest,
    version: options.version,
    scriptsDomainUrl: serviceTopology.scriptsDomainUrl
  })
}

siteModel.santaBase = config.baseUrl
serviceTopology.staticServerFallbackUrl = serviceTopology.staticServerFallbackUrl || 'https://fallback.wix.com/'
siteModel.baseVersion = getBaseVersion(siteModel.santaBase)
siteModel.santaBaseFallbackUrl = siteModel.baseVersion ? joinURL(serviceTopology.staticServerFallbackUrl, siteModel.baseVersion) : null

requirejs.config(config)
window.define('experiment', [], () => experimentInst)

const mobileView = mobile.isMobileView(window, siteModel, queryUtil)

const prefetcher = resourcePrefetch(
  window,
  siteModel,
  publicModel,
  pageInfo,
  wixBiSession,
  isServerSide,
  mobileView,
  experimentInst,
  requirejs
)

try {
  window.document.domain = getSubdomain(window.document.domain)
} catch (e) {
  // empty
}

window.isPreview = queryUtil.isParameterTrue.bind(null, 'isEdited')
const isExternalPreview = rendererModel.previewMode

render(
  isServerSide,
  isPreview,
  isExternalPreview,
  prefetcher,
  queryUtil,
  siteModel,
  wixBiSession,
  mobileView,
  config,
  performanceBI
)

if (wixBiSession.sendBeat) {
  wixBiSession.sendBeat(4, 'main-r executed')
}
